export enum QuestionnaireMasterAvailability {
    ALL_ITEMS = 0,
    COMPLIANCE_ITEMS = 1,
    REQUEST_ITEMS = 2
}
